module.exports = __webpack_public_path__ + "img/08axbr721.3fb16b52.png";